
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			textValue: ""
		};
	},
	props: {
		toEditValue: {
			type: String,
			default: ()=>""
		}
	},
	computed: {
		isValid():boolean{
			if (this.textValue.trim().length == 0) return false;
			if (this.textValue.trim().length > 500) return false;
			return true;
		}
	},
	watch: {
		toEditValue: {
			immediate: true,
			handler(){
				this.textValue = this.toEditValue;
			}
		}
	},
	methods: {
		confirm(){
			this.$emit("input", this.textValue);
			this.$emit("close");
		},
		cancel(){
			this.$emit("close");
		}
	},
	i18nEx: {
		componentPrefix: "components.cars"
	}
});
